/**
 * Expects the component to have a form with a textarea named "comment".
 * @constructor
 * @extends {Foundation.Component}
 * @param {string|jQuery} component
 */
Foundation.PostCommentComponent = function (component) {
    Foundation.Component.call(this, component);

    /**
     * Comment posting results for the most recent comment the user
     * has posted.
     * @type {Foundation.API}
     * @private
     */
    this.comment = null;

    /**
     * We really need an abstracted way of dealing with member preferences
     * instead of relying on these ad-hoc cookies. HTML5 localStorage would
     * be far better backing store for this sort of data.
     * @type {Foundation.Cookie}
     * @private
     */
    this.fbShareCookie = new Foundation.Cookie("shareCommentOnFacebook");

    /**
     * Feeling shy login data.
     * @private
     */
    this.feelingShyData = null;

    /**
     * The post comment form view.
     * @type {Foundation.Form}
     * @private
     */
    this.form = null;

    var commentForm = this.view.find("textarea[name=comment]").closest("form");
    if (commentForm[0]) {
        this.form = new Foundation.Form(commentForm[0], this.postComment.bind(this));
        this.registerForm(this.form);

        if (this.fbShareCookie.getValue() === "true") {
            this.view.find("[name=shareCommentOnFacebook]").prop("checked", true);
        }

        this.form.setFeelingShyDelegate(this.setFeelingShyData.bind(this));

        this.form.observe("change", this.handleFormChange.bind(this));
    }
    else {
        Foundation.warn("Couldn't find comment form.", component);
    }
};
Foundation.inherit(Foundation.PostCommentComponent, Foundation.Component);

/**
 * @param {Foundation.Observable.Event=} e
 */
Foundation.PostCommentComponent.prototype.handleFormChange = function (e) {
    var values = /** @type {Object.<string,*>} */ (e.data);
    var shareCommentOnFacebook = values["shareCommentOnFacebook"] === "yes";
    this.fbShareCookie.setValueAndSave(shareCommentOnFacebook ? "true" : "false");
};

/**
 * @param {Object.<string,string>} feelingShyData
 */
Foundation.PostCommentComponent.prototype.setFeelingShyData = function (feelingShyData) {
    this.feelingShyData = feelingShyData;
};

/**
 * @param {Object.<string,*>} values
 * @return {!Foundation.Promise}
 * @private
 */
Foundation.PostCommentComponent.prototype.postComment = function (values) {
    // Extend values we send to the API with feeling shy data if the user
    // opted for a "feeling shy" login.
    if (this.feelingShyData) {
        Foundation.extend(values, this.feelingShyData);
        this.feelingShyData = null;
    }

    // Perform the Foundation.API request to post a new comment.
    this.comment = new Foundation.API("POST", "Comment", values);

    // Load the new comment into the view on success of the API call.
    this.comment.then(this.loadNewComment.bind(this));

    // Return the Foundation.API instance to Foundation.Form so it can track our
    // progress.
    return this.comment;
};

/**
 * Tell the comments component, or anyone else who may care, that a
 * comment has been added.
 * @private
 */
Foundation.PostCommentComponent.prototype.loadNewComment = function () {
      var nc = Foundation.NotificationCenter.sharedNotificationCenter();
      nc.fire("comment:added", this.comment);
      // clear text field
      this.view.find("textarea[name=comment]").val("");
};

// ---------------------------------------------------------------------

window["Foundation"]["PostCommentComponent"] = Foundation.PostCommentComponent;
